import apiClient from "../request/http-common";

class P2PChatService {
    
    // Initialize chat: backend has no explicit init endpoint.
    // Treat initialization as ensuring messages endpoint is reachable.
    async initializeChat(orderId) {
        try {
            const response = await apiClient.get(`/api/p2p/orders/${orderId}/chat`);
            return { success: true, preview: response.data?.messages || [] };
        } catch (error) {
            console.error('Initialize chat error:', error);
            throw error;
        }
    }

    // Get chat messages for an order
    async getChatMessages(orderId) {
        try {
            const response = await apiClient.get(`/api/p2p/orders/${orderId}/chat`);
            return response.data;
        } catch (error) {
            console.error('Get chat messages error:', error);
            throw error;
        }
    }

    // Send a chat message
    async sendMessage(orderId, message) {
        try {
            const response = await apiClient.post(`/api/p2p/orders/${orderId}/chat`, {
                message: message.trim()
            });
            return response.data;
        } catch (error) {
            console.error('Send message error:', error);
            throw error;
        }
    }

    // Mark messages as read
    async markAsRead(orderId) {
        try {
            const response = await apiClient.post(`/api/p2p/orders/${orderId}/chat/read`);
            return response.data;
        } catch (error) {
            console.error('Mark as read error:', error);
            throw error;
        }
    }

    // Get unread message count
    async getUnreadCount(orderId) {
        try {
            const response = await apiClient.get(`/api/p2p/orders/${orderId}/chat/unread-count`);
            return response.data;
        } catch (error) {
            console.error('Get unread count error:', error);
            throw error;
        }
    }

    // Get all chat sessions for user
    async getAllChatSessions() {
        try {
            const response = await apiClient.get('/api/p2p/chat/sessions');
            return response.data;
        } catch (error) {
            console.error('Get chat sessions error:', error);
            throw error;
        }
    }

    // Upload image and send as chat message (backend accepts generic /api/upload)
    async sendImage(orderId, file) {
        try {
            const formData = new FormData();
            formData.append('file', file);

            const uploadRes = await apiClient.post('/api/upload', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            const fileUrl = uploadRes?.data?.file_url || uploadRes?.data?.url || uploadRes?.data?.filename;
            if (!fileUrl) throw new Error('Upload did not return a file URL');

            const messageText = typeof fileUrl === 'string' ? fileUrl : JSON.stringify(fileUrl);
            const sendRes = await this.sendMessage(orderId, messageText);
            return sendRes;
        } catch (error) {
            console.error('Send image error:', error);
            throw error;
        }
    }

    // Report inappropriate message
    async reportMessage(orderId, messageId, reason) {
        try {
            const response = await apiClient.post('/api/p2p/chat/report', {
                order_id: orderId,
                message_id: messageId,
                reason: reason
            });
            return response.data;
        } catch (error) {
            console.error('Report message error:', error);
            throw error;
        }
    }

    // Get chat history with pagination
    async getChatHistory(orderId, page = 1, limit = 50) {
        try {
            const response = await apiClient.get(`/api/p2p/orders/${orderId}/chat/history`, {
                params: { page, limit }
            });
            return response.data;
        } catch (error) {
            console.error('Get chat history error:', error);
            throw error;
        }
    }

    // Close/end chat session
    async closeChat(orderId) {
        try {
            const response = await apiClient.post(`/api/p2p/orders/${orderId}/chat/close`);
            return response.data;
        } catch (error) {
            console.error('Close chat error:', error);
            throw error;
        }
    }
}
const p2pChatServiceInstance = new P2PChatService();
export default p2pChatServiceInstance;
